import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const MainBlock = styled.div``;

export const stylesOptions = css`
  &:hover {
    background-color: #fffbeb;
  }
`;
